import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { EmailSettingsPanel } from "@/components/admin/email/EmailSettingsPanel";

export const Route = createFileRoute("/_authenticated/admin/email/settings")({
  head: () => ({
    meta: [
      { title: "Админ — Имейл · Настройки | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <EmailSettingsPanel />
    </AdminLayout>
  ),
});
